exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2rOmvPZ6n7ldyvn70IZAOa{max-height:436px}", ""]);
// Exports
exports.locals = {
	"categoryMenu": "_2rOmvPZ6n7ldyvn70IZAOa"
};